import styled, {
  css,
} from 'styled-components';

export const getButtonStyles = (props: Object) => {
  let cursor = 'pointer';
  let height = '32px';
  let lineHeight = '32px';
  let padding = '0 10px';
  let verticalAlign = 'middle';
  let width = 'auto';

  let color = '#505F79';
  let background = 'rgba(9, 30, 66, 0.04)';
  let hoverColor = '#505F79';
  let hoverBackground = 'rgba(9, 30, 66, 0.08)';
  let hoverTextDecoration = 'none';

  if (props.appearance === 'link') {
    color = '#0052CC';
    background = 'transparent';
    hoverColor = '#0052CC';
    hoverBackground = 'transparent';
    hoverTextDecoration = 'underline';
  }

  if (props.appearance === 'primary') {
    color = '#fff';
    background = '#0052CC';
    hoverColor = '#fff';
    hoverBackground = '#0065FF';
  }

  if (props.isSelected) {
    color = '#F4F5F7';
    background = '#253858';
    hoverColor = '#F4F5F7';
    hoverBackground = '#253858';
  }

  if (props.isDisabled) {
    color = '#A5ADBA';
    background = 'rgba(9, 30, 66, 0.04)';
    hoverColor = '#A5ADBA';
    hoverBackground = 'rgba(9, 30, 66, 0.04)';
  }

  // Spacing: Compact
  if (props.spacing === 'compact') {
    height = '18px';
    lineHeight = '18px';
    padding = '0 5px';
  }

  // Spacing: None
  if (props.spacing === 'none') {
    height = 'auto';
    lineHeight = 'inherit';
    padding = '0';
    verticalAlign = 'baseline';
  }

  // Disabled
  if (props.disabled) {
    cursor = 'not-allowed';
  }

  // Fit to parent width
  if (props.fit) {
    width = '100%';
  }

  return css`
    align-items: baseline;
    background: ${background};
    border-radius: 3px;
    border-width: 0;
    box-sizing: border-box;
    color: ${color};
    cursor: ${cursor};
    display: flex;
    font-size: inherit;
    font-style: normal;
    height: ${height};
    line-height: ${lineHeight};
    margin: 0;
    max-width: 100%;
    outline: none !important;
    padding: ${padding};
    pointer-events: auto;
    text-align: center;
    text-decoration: none;
    transition: background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
    transition-duration: 0.1s, 0.15s;
    vertical-align: ${verticalAlign};
    white-space: nowrap;
    width: ${width};
    box-shadow: none;
    user-select: none;

    &::-moz-focus-inner {
      border: 0;
      margin: 0;
      padding: 0;
    }

    &:hover {
      color: ${hoverColor};
      background: ${hoverBackground};
      text-decoration: ${hoverTextDecoration};
    }

    &:active {
      transition-duration: 0s;
    }

    &:focus {
      outline: none;
      transition-duration: 0s, 0.2s;
    }
  `;
};

export const StyledButton = styled.button`
  ${getButtonStyles};
`;
